<template>
  <div class="contact-form">
    <v-row align="center" class="pt-16">
      <v-col
        cols="12"
        :sm="product.hotspotGallery[0] ? 6 : 8"
        :offset-sm="product.hotspotGallery[0] ? 0 : 2"
        :md="product.hotspotGallery[0] ? 5 : 4"
        :offset-md="product.hotspotGallery[0] ? 1 : 4"
      >
        <ButtonBack @click.native="$emit('on-back')" />
        <v-form v-model="form.valid">
          <span>{{ $root.allLanguages[$language.current].contactFormText1 }}</span>
          <v-text-field
            hide-details
            v-model="form.name"
            :rules="form.nameRules"
            label=""
            class="bodoni"
            required
          />
          <br>
          <span>{{ $root.allLanguages[$language.current].contactFormText2 }}</span>
          <span>{{ $root.allLanguages[$language.current].contactFormText3 }}</span>
          <v-text-field
            hide-details
            v-model="form.email"
            :rules="form.emailRules"
            label=""
            class="bodoni"
            required
          />
          <span>{{ $root.allLanguages[$language.current].contactFormText4 }}</span>
          <v-text-field
            hide-details
            v-model="form.phone"
            type="number"
            label=""
            class="bodoni"
          />
          <br>
          <span v-if="product.SKU" class="pt-8">{{ $root.allLanguages[$language.current].contactFormProductID }}</span>
          <v-text-field
            v-if="product.SKU"
            hide-details
            :value="product.SKU"
            disabled
            class="bodoni"
          />
        </v-form>
        <div class="my-8">
          <h4>{{ product[$language.current + 'Description'] || '' }}</h4>
        </div>
      </v-col>
      <v-col v-if="product.hotspotGallery[0]" cols="12" sm="6" md="4" offset-md="1">
        <v-img
          :src="'/media/' + product.hotspotGallery[0].id"
          transition="fade"
          max-height="80vh"
          contain
        />
      </v-col>
    </v-row>
    <v-row class="pb-16 pt-6">
      <v-col cols="12">
        <button
          v-if="!emailSent"
          :disabled="!form.valid"
          @click="sendEmail"
          class="button-contact uppercase"
        >
          {{$root.allLanguages[$route.params.language].sendEmail}}
        </button>
        <a
          v-if="$root.platform.phone"
          @click="showContact = true"
          href="tel:+3905575927010"
          class="mt-3 button-contact phone uppercase text-align-center"
        >
          {{$root.allLanguages[$route.params.language].callUs}}
        </a>
      </v-col>
    </v-row>
    <transition name="form-message" mode="out-in">
      <h4 v-show="emailSent" class="form-message">{{$root.allLanguages[$route.params.language].emailSent}}</h4>
    </transition>
    <transition name="form-message" mode="out-in">
      <h4 v-show="showError" class="form-message">{{$root.allLanguages[$route.params.language].error}}</h4>
    </transition>
  </div>
</template>

<script>
import enCountryCode from '@/assets/data/en-country-code.json'
import itCountryCode from '@/assets/data/it-country-code.json'
import frCountryCode from '@/assets/data/fr-country-code.json'
import jpCountryCode from '@/assets/data/jp-country-code.json'
import cnCountryCode from '@/assets/data/zh-country-code.json'
import title from '@/assets/data/title-multilanguage.json'
import ButtonBack from '@/atoms/ButtonBack.vue'
import axios from 'axios'

export default {
  name: 'ContactForm',
  props: {
    product: {
      type: Object
    }
  },
  components: { ButtonBack },
  data () {
    return {
      enCountryCode,
      itCountryCode,
      frCountryCode,
      jpCountryCode,
      cnCountryCode,
      emailSent: false,
      showError: false,
      title,
      form: {
        valid: false,
        // title: '',
        name: '',
        // surname: '',
        nameRules: [
          v => !!v,
          v => (v && v.length <= 20)
        ],
        // surnameRules: [
        //   v => !!v || this.$root.allLanguages[this.$route.params.language].required,
        //   v => (v && v.length <= 20) || '*'
        // ],
        email: '',
        emailRules: [
          v => !!v,
          v => /.+@.+\..+/.test(v)
        ],
        countryCode: '',
        phone: '',
        comment: ''
      }
    }
  },
  computed: {
    localizedTitle () {
      return this.title[this.$route.params.language]
    },
    countryCodeList () {
      const cclist = []

      for (let i = 0; i < this[this.$route.params.language + 'CountryCode'].length; i++) {
        const element = this[this.$route.params.language + 'CountryCode'][i]
        cclist.push(element.name + ' +' + element.phone_code)
      }
      return cclist
    }
  },
  methods: {
    async sendEmail () {
      if (this.form.valid) {
        this.showError = false
        const userEmail = {
        // title: this.form.title,
          name: this.form.name,
          surname: ' ',
          email: this.form.email,
          phone: ' ', // opzionale
          productid: this.product.SKU,
          message: ' '
        }
        try {
          const result = await axios.post('https://gucci-garden-tour-master.monogrid.io/api/send-email', userEmail)
          if (result.data.success) {
            this.emailSent = true
            if (window.dataLayer && this.product) {
              window.dataLayer.push({
                event: 'generic_event',
                eventCategory: this.product.SKU
                  ? this.$route.params.roomName.split('-')[1] + ' - SKU' + (this.product.oneOfAKind ? ' - UNICUM' : '')
                  : 'Clicks on Extra CTAs',
                eventAction: (this.product.SKU || this.$route.params.roomName.split('-')[1]),
                eventLabel: this.product.SKU ? 'Email Sent' : 'Book Email Sent'
              })
            }
          } else {
            this.showError = true
            setTimeout(() => {
              this.showError = false
            }, 2500)
          }
        } catch (e) {
          this.showError = true
          setTimeout(() => {
            this.showError = false
          }, 2500)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-message-enter-active,
.form-message-leave-active {
  transition: all 0.25s ease-in-out;
}

.form-message-enter,
.form-message-leave-to {
  opacity: 0;
  transform: translate(-50%, 100%) !important;
}

.contact-form {
  height: 100%;
}

.button-contact {
  display: block;
  outline: none;
  width: 100%;
  max-width: 200px;
  margin: 0 auto;
  border-radius: 16px;
  padding: 6px 12px;
  background-color: $c-white;
  transition: all 0.25s $ease-in-out-quad;

  &:disabled {
    opacity: 0.2;
  }

  &:hover:not(:disabled) {
    background: $c-black;
    color: $c-white;
  }

  &.phone {
    pointer-events: all;
    opacity: 1;
  }
}

.button-close {
  top: 20px;
  left: 20px;
  position: absolute;

  @include breakpoint('xs-only') {
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
}

form span {
  display: inline-block;
  font-size: 32px;
  font-weight: 100;

  @include breakpoint ('sm-and-down') {
    font-size: 22px;
  }
}

::v-deep .v-text-field input {
  max-width: 250px;
  color: $c-black !important;
  font-size: 32px;
  font-weight: 100;
  margin: 0;
  padding: 0;
  text-align: center;

  @include breakpoint ('sm-and-down') {
    max-width: 175px;
    font-size: 22px;
  }

  @include breakpoint ('xs-only') {
    max-width: 150px;
  }
}

::v-deep .v-text-field {
  padding: 0;
  margin: 0;
}

::v-deep .v-input {
  display: inline-block;
}

::v-deep .error--text .v-input__slot {
  border: 1px solid $c-red;
  border-top: 0;
  border-right: 0;
  border-left: 0;
  margin: 0;
  padding: 0;
}

::v-deep .v-input__slot {
  border: 1px solid $c-black-20;
  border-top: 0;
  border-right: 0;
  border-left: 0;
  margin: 0;
  padding: 0;
  background-color: transparent;

  &::after,
  &::before {
    border-style: none;
    display: none;
  }
}

.line {
  max-width: 175px;
  height: 1px;
  background-color: $c-black;
  opacity: 0.2;
}

// .form-row {
//   height: 100%;

//   @include breakpoint ('md-and-down') {
//     height: auto;
//   }
// }

.form-message {
  position: fixed;
  bottom: 10%;
  left: 50%;
  transform: translateX(-50%);
  background-color: $c-white;
  padding: 6px 12px;
  text-align: center;

  @include breakpoint ('xs-only') {
    width: 100%;
    bottom: 0;
  }
}
</style>
